import {Modal, Select, Row} from 'antd';
import {useState} from 'react';

export const TransferAllModal = ({roomOptions, open, onOk, onCancel, props}) => {
    const [roomId, setRoomId] = useState(undefined);

    const onRoomChange = (val) => {
        setRoomId(val)
    }

    const onModalOk = () => {
        if (onOk) {
            onOk(roomId);
        }
    }

    const rowStyle = {
        marginTop: '5px',
        marginBottom: '5px'
    }

    const disabled = roomOptions.length === 0;

    return <Modal title={`Enter the Destination Room to Transfer`} open={open} onOk={onModalOk} onCancel={onCancel}>
        <Row style={{...rowStyle, color: 'red'}}>
            <b>All plants in selected groups will be transferred.</b>
        </Row>
        <Row style={rowStyle}>
            <Select value={roomId} placeholder={'Destination'} options={roomOptions} onChange={onRoomChange} popupMatchSelectWidth={false} disabled={disabled}/>
        </Row>
    </Modal>
}